import { Component, HostBinding, Input } from '@angular/core';
import { BaseDirective } from '../../../base.directive';

@Component({
    selector: 'span[euiIcon], i[euiIcon], eui-icon',
    template: '<ng-content></ng-content>',
})
export class EuiIconComponent extends BaseDirective {
    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }

    @Input() iconClass;
    @Input() isLoading = false;
    @HostBinding('attr.aria-label')
    @Input('aria-label')
    public get ariaLabel(): string {
        return this._ariaLabel;
    }
    public set ariaLabel(value: string|null) {
        this._ariaLabel = value;
    }

    protected _ariaLabel = 'eUI Icon';

    constructor() {
        super();
    }

    getCssClasses() {
        return [
            super.getCssClasses('eui-icon'),
            this.iconClass && !this.isLoading ? this.iconClass : ``,
            this.isLoading ? 'eui-u-loading' : '',
        ].join(' ').trim();
    }
}
